// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IMediaRequestCommandParams {
	mediaRequestId: string | undefined;

	$type?: string | undefined;
}
export class MediaRequestCommandParams {
	constructor(data?: IMediaRequestCommandParams) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	mediaRequestId: string | undefined;

	static $type: string = "CoreApi.Models.DeviceCommands.MediaRequestCommandParams, ";
	$type?: string | undefined = MediaRequestCommandParams.$type;
}

